<template>
  <div class="barMain" :class="{
    barExpanded: $store.state.message.isReplyMessageOpen,
    barCollapsed: !$store.state.message.isReplyMessageOpen
  }"
  >
    <div class="repliedMessageContainer">
      <RepliedMessageRow v-if="$store.state.message.ReplyMessage" :message="$store.state.message.ReplyMessage" class="repliedMessageOverride" />
      <div class="imageContainer">
        <img src="@/assets/images/close4.png" class="imageClose" @click="clearReplyMessage">
      </div>
    </div>
  </div>
</template>

<script>
import RepliedMessageRow from '@/components/home/rightcolumn/messages/messageTypes/common/RepliedMessageRow.vue'
export default {
  components: {
    RepliedMessageRow
  },

  data () {
    return {
      emojiList: [],
      selectedTabIndex: 0
    }
  },

  methods: {
    clearReplyMessage () {
      this.$store.state.message.isReplyMessageOpen = false
      setTimeout(() => {
        this.$store.state.message.ReplyMessage = null
        this.$store.state.conversation.activeConversation.newMessage.ReplyMessage = null
      }, 300)
    }
  },

  mounted () {
  }
}

</script>

<style scoped>
  .barMain {
    height: 0px;
    background-color: rgba(190, 190, 190, 0.45);
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex-shrink: 0;
    overflow: hidden;
  }

  .barExpanded {
    height: 90px;
    transition: height 0.3s;
  }

  .barCollapsed {
    height: 0px;
    transition: height 0.3s;
  }

  .repliedMessageContainer {
    display: flex;
    flex-shrink: 0;
    flex-grow: 1;
    flex-direction: row;
    justify-content: center;
    margin-top: 10px;
  }

  .repliedMessageOverride {
    width: 85%;
  }

  .imageContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .imageClose {
    width: 25px;
    height: 25px;
    margin-left: 15px;
    cursor: pointer;
  }
</style>
